<template>
  <div class="header-info-com">
    <div class="left-logo">
      <p class="icon-logo"></p>
      <!-- <p class="text-logo">山野电器</p> -->
    </div>

    <div class="right-operate">
      <a-dropdown>
        <p class="user-name">{{ userInfo.user_name }}</p>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="toInfo">
              <p>个人中心</p>
            </a-menu-item>
            <a-menu-item v-if="state.isProxyLogin" @click="backLogin">
              <p>返回代登录账号</p>
            </a-menu-item>
            <a-menu-item @click="logout">
              <p>退出登录</p>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { backProxyLogin, loginOut } from "@/hook/useLogin";
import { PROXY_TOKEN_STORAGE } from "@/hook/useConstant";
import { getStorage } from "@/hook/useStorage";

const store = useStore();
const router = useRouter();

const userInfo = computed(() => {
  let userInfo = store.state.userInfo;
  if (!userInfo) {
    return {};
  }
  return userInfo;
});

const state = reactive({
  isProxyLogin: false, // 是否为代登录账号
});

// 跳转个人信息
const toInfo = () => {
  router.push({
    name: "userInfo",
  });
};

// 退出登录
const logout = () => {
  loginOut();
};

// 返回代登录账号
const backLogin = () => {
  backProxyLogin();
};

watch(
  store.state,
  (newPath, oldPath) => {
    state.isProxyLogin = !!getStorage(PROXY_TOKEN_STORAGE);
  },
  { deep: true }
);

onMounted(() => {});
</script>
<style lang="less" scoped></style>
